import React from "react";
import Nav from "./Nav";
import BannerImage from "../Assets/home-banner-background.png";
import PizzaImage from "../Assets/home-banner-image.png";

const Home = () => {
  return (
    <div className="home-container" id="home">
      <Nav />

      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerImage} alt="pizza store" />
        </div>
        <div className="home-text-section">
          <h1 className="primary-heading">
            Your Favorite Pizza Delivered Hot & Tasty
          </h1>
          <p className="primary-text">
            Explore our diverse range of mouthwatering pizza options. Signature
            recipes crafted for the ultimate pizza experience.
          </p>
          <button
            onClick={() => {
              const el = document.getElementById("menu");
              if (el) {
                const yOffset = -150;
                const y =
                  el.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({ top: y, behavior: "smooth" });
              }
            }}
            style={{
              padding: "10px 20px",
              fontSize: "16px",
              backgroundColor: "#fe9e0d",
              color: "white",
              border: "1px solid #b36b00",
              borderRadius: "6px",
              cursor: "pointer",
            }}
          >
            View Menu
          </button>
        </div>
        <div className="home-image-secton">
          <img src={PizzaImage} alt="pizza shop" />
        </div>
      </div>
    </div>
  );
};

export default Home;
